let community_data = [
    {
        name: "테니스의 0점은 'LOVE'다",
        content: '신사의 스포츠라고 불리는 테니스는 영국과 프랑스 귀족들이 즐기던 스포츠였다.',
        type: '컬쳐',
        imgUrl: '/img/community1.jpg'
    },
    {
        name: "초보자를 위한 라켓 선택 GUIDE 4",
        content: '갓 테니스를 시작한 혹은 시작할 예정인 테린이를 위한 라켓 선택 가이드',
        type: '컬쳐',
        imgUrl: '/img/community2.jpg'
    },
    {
        name: "테니스의 맛",
        content: '시간에 공을 들여야 결과가 만들어지는 것들이 있다. 테니스도 시간과 노력이 필요한 운동이다.',
        type: '피플',
        imgUrl: '/img/community3.jpg'
    },
    {
        name: "Kitschivin's Color of Tennis",
        content: '광고인이자 패션 유튜버 키치빈의 컬러풀 테니스',
        type: '피플',
        imgUrl: '/img/community4.jpg'
    },
    {
        name: "테니스 코트별 특성 3. 잔디코트",
        content: "역대 최고의 선수가 누구인지 딱 한 명만 꼽는 건 매우 어려운 일이지만 '잔디 코트위의 최고'를" + 
        "꼽는다면 그건 어렵지 않다.",
        type: '컬쳐',
        imgUrl: '/img/community5.jpg'
    },
    {
        name: "테니스 코트별 특성 2. 클레이코트",
        content: "테니스를 잘 모르는 사람도 흙신 '라파엘 나달'이란 이름은 어디선가 한 번쯤 들어봤을 것이다.",
        type: '컬쳐',
        imgUrl: '/img/community6.jpg'
    },
    {
        name: "테니스의 기쁨2",
        content: "테니스가 좋아서 주말을 손꼽아 기다리는 사람들을 만났다.",
        type: '피플',
        imgUrl: '/img/community7.jpg'
    },
    {
        name: "광화문 세종대왕 동상 아래서 테니스를,",
        name2: '2023 화이트오픈 서울',
        content: "휠라의 광화문 광장 新개념 테니스 축제",
        type: '아카이브',
        imgUrl: '/img/community8.jpg'
    },
    {
        name: "테니스의 기쁨1",
        content: "테니스가 좋아서 주말을 손꼽아 기다리는 사람들을 만났다.",
        type: '피플',
        imgUrl: '/img/community9.jpg'
    },
    {
        name: "테니스 코트별 특성 1.하드코트",
        content: "하드코트는 말 그대로 딱딱한 코트를 의미한다.",
        type: '컬쳐',
        imgUrl: '/img/community10.jpg'
    },
    {
        name: "권순우 선수의 How to SHOT",
        content: "Lesson #4.",
        content2: '권순우 선수처럼 드롭샷하기',
        type: 'How to tennis',
        imgUrl: '/img/community11.jpg'
    }
]


export default community_data;